module.exports = __webpack_public_path__ + "img/mclean.14181809.jpg";